module.exports = __webpack_public_path__ + "img/1x.8117d11.jpg";